<template>
  <v-layout
    v-if="dialog"
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="38em"
    >
      <v-form
        id="check-login-form"
        ref="form"
        @submit.prevent="updateDate()"
      >
        <v-card
          class="dialog-update-date"
          pa-5
        >
          <v-card-title class="pb-0">
            <span class="swal2-title dialog-update-date__title pa-0">
              {{ this.$t('app.contratacoes.components.buttons.transferDate.dialog.title') }}
            </span>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <span class="dialog-update-date__text pa-0">
                  {{ this.$t('app.contratacoes.components.buttons.transferDate.dialog.message',
                             {data: dataDaContratacao}) }}
                </span>
              </v-flex>
              <v-flex
                xs6
                class="mt-4"
              >
                <date-picker
                  id="dateField"
                  :key="row.id"
                  v-model="payload.dataRepasse"
                  required
                  :rules="[requiredRule,
                           dateGreaterThan(row.dataContratacao,
                                           { valueDateFormat: 'DD/MM/YYYY',
                                             errorMessage: dateValidationMessage })]"
                  :label="$t('app.contratacoes.components.buttons.transferDate.dialog.input')"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0 swal2-actions dialog-actions">
            <v-spacer />
            <v-btn
              id="cancelBtn"
              class="swal2-cancel
                swal2-styled dialog-actions__button dialog-actions__button--cancel"
              flat
              @click.native="cancel()"
            >
              {{ this.$t('app.contratacoes.list.cancel') }}
            </v-btn>
            <v-btn
              class="swal2-confirm
                swal2-styled dialog-actions__button dialog-actions__button--continue"
              flat
              type="submit"
              form="check-login-form"
            >
              {{ this.$t('app.contratacoes.list.continue') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import NotificationMixin from 'Support/mixins/notification-mixin';
import DatePicker from 'Support/components/pickers/DatePicker.vue';
import Moment from 'moment';
import RulesMixin from 'Support/mixins/rules-mixin';
import ContratacoesRequest from 'Domain/contratacoes/ContratacoesRequest';

export default {
  name: 'DialogAtualizarRepasse',
  components: {
    DatePicker,
  },
  mixins: [NotificationMixin, RulesMixin],
  props: {
    dialog: {
      type: Boolean,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    payload: {
      dataRepasse: '',
    },
    dateValidationMessage: 'app.contratacoes.components.buttons.transferDate.dialog.dateValidation',
  }),
  computed: {
    dataDaContratacao() {
      return Moment(this.row.dataContratacao).format('DD/MM/YYYY');
    },
  },
  methods: {
    exibirOkDialog(title, text) {
      this.showOkDialog({
        title,
        text,
        confirmButtonText: 'OK',
        width: '35em',
      });
    },
    updateDate() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const loader = this.$loading.show();
      let title = '';
      let message = '';
      ContratacoesRequest
        .updateTransferDate(this.row.id, this.payload)
        .then(() => {
          title = this.$t('app.contratacoes.list.successTitle');
          message = this.$t('app.contratacoes.list.dateSuccessMessage');
        })
        .catch(() => {
          title = this.$t('app.contratacoes.list.errorTitle');
          message = this.$t('app.contratacoes.list.dateErrorMessage');
        })
        .finally(() => {
          this.exibirOkDialog(
            title,
            message,
          );
          loader.hide();
          this.$root.$emit('refresh-crud', {});
          this.$emit('update:dialog', false);
        });
    },
    cancel() {
      this.payload.dataRepasse = '';
      this.$emit('update:dialog', false);
    },
  },
};
</script>

<style lang="stylus" scoped>
.dialog-update-date
  border-radius 1em
  padding 32px

.dialog-update-date__text
  font-family Open Sans
  font-style normal
  font-weight normal
  font-size 16px
  line-height 24px
  color #9E9E9E

.dialog-update-date__title
  font-family Open Sans
  font-style normal
  font-weight 600
  font-size 20px
  line-height 27px
  color #121212

.dialog-actions__button:hover:before
    background-color: unset !important

.dialog-actions__button
  font-family Roboto
  font-style normal
  font-weight 500
  font-size 14px
  line-height 16px
  text-align right
  letter-spacing 0.75px
  text-transform uppercase
  background-color transparent

.dialog-actions__button--continue
  border-left-color rgb(255, 255, 255)
  border-right-color rgb(255, 255, 255)
  color #EB3237

.dialog-actions__button--cancel
  color #FC888C
</style>
